import { useRef } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useNonInitialRenderHook = (func, deps) => {
    const didMount = useRef(false);

    useEffectWithErrorLogging(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
};

export default useNonInitialRenderHook;
